import React from "react";
import { useTranslation } from "react-i18next";
import SubTitle from "components/SubTitle";
import FullPieChart from "common/components/FullPieChart/FullPieChart";
import { ReportsCompletedByRoles } from "pages/Dashboards/types";
import Trend from "../Components/Trend";
import { ReportsCompletedTodayTypes } from "./types";
import {
  getReportCompletedChartDataArray,
  getReportsCompletedDataArray,
} from "./utils";

type Props = {
  data: ReportsCompletedByRoles;
};

const ReportsCompletedToday = ({ data }: Props) => {
  const { t } = useTranslation();
  const reportsCompletedData: ReportsCompletedTodayTypes[] =
    getReportsCompletedDataArray(data);

  return (
    <div className="reports-completed-container data-box">
      <SubTitle className="title">{t("ReportsCompletedToday")}</SubTitle>
      <div className="row-container dashed-inner-border">
        {reportsCompletedData.map(
          ({
            reporterTitle,
            notCompletedColor,
            dataByController,
          }: ReportsCompletedTodayTypes) => (
            <div className="container-by-reporter" key={`div-${reporterTitle}`}>
              <SubTitle className="reporter-name">{reporterTitle}</SubTitle>

              <div className="data-container">
                <Trend
                  isIncrease={dataByController.trendIsIncrease}
                  isPercentage
                  amount={dataByController.percentageByCompleteOrNot}
                  trendPercent={dataByController.trendPercentageByPeriod}
                  periodAverageTitle={t("dailyAverage")}
                />
                <div className="pie-data-container">
                  <div className="amounts-container">
                    <div className="amount">
                      <div className="dot" />
                      <p>
                        {dataByController.reportCompleted}
                        {` `}
                        {t("completed")}
                      </p>
                    </div>
                    <div className="amount">
                      <div
                        className="dot"
                        style={{ backgroundColor: notCompletedColor }}
                      />
                      <p>
                        {dataByController.reportNotCompleted}
                        {` `}
                        {t("notCompleted")}
                      </p>
                    </div>
                  </div>
                  <FullPieChart
                    data={getReportCompletedChartDataArray(
                      dataByController.reportCompleted,
                      dataByController.reportNotCompleted,
                      notCompletedColor
                    )}
                  />
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ReportsCompletedToday;
